import { Component, inject, input } from '@angular/core';
import { PostalCodeService } from 'src/app/services/postal-code.service';
import { FormAreaComponent } from "src/app/components/form-area/form-area.component";
import { SelectComponent } from "src/app/components/select/select.component";
import { TranslateModule } from '@ngx-translate/core';
import { InputComponent } from "src/app/components/input/input.component";
import { addressTypeOptions, stateEnumOptions } from './address.constants';

@Component({
  selector: 'app-address-form',
  standalone: true,
  imports: [
    FormAreaComponent,
    SelectComponent,
    TranslateModule,
    InputComponent
  ],
  templateUrl: './address-form.component.html'
})
export class AddressFormComponent {
  private readonly postalCodeService = inject(PostalCodeService);
  control = input.required<any>();
  addressTypeOptions = addressTypeOptions;
  stateEnumOptions = stateEnumOptions;

  getAddressByPostalCode() {
    const postalCode = this.control().get('zipCode')?.value;
    this.postalCodeService.getAddresByPostalCode(postalCode).subscribe((response) => {
      this.control().get('state').setValue(response.uf);
      this.control().get('city').setValue(response.localidade);
      this.control().get('neighborhood').setValue(response.bairro);
      this.control().get('street').setValue(response.logradouro);
    });
  }
}

